import React from 'react';
import { Block, FormBlockLabel as Label, FormTextInput as Input, Heading, Paragraph } from '../../devlink/_Builtin';
import { MortgageFormData, FORM_STEPS } from '../types/mortgage';

interface FormStep3Props {
  formData: Partial<MortgageFormData>;
  errors: Record<string, string>;
  updateFormData: (field: keyof MortgageFormData, value: any) => void;
}

const FormStep3: React.FC<FormStep3Props> = ({ formData, errors, updateFormData }) => {
  const stepInfo = FORM_STEPS[2];

  return (
    <Block>
      <div>
        <Heading tag="h2">{stepInfo.title}</Heading>
        <Paragraph>{stepInfo.description}</Paragraph>
      </div>

      <div>
        <Heading tag="h3">Monthly Expenses</Heading>
        <div>
          <div>
            <Label htmlFor="leisureExpenses">
              Leisure & Entertainment (£) *
            </Label>
            <Input
              value={formData.leisureExpenses?.toString() || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('leisureExpenses', Number(e.target.value))}
              type="number"
              placeholder="0"
            />
            {errors.leisureExpenses && (
              <span>{errors.leisureExpenses}</span>
            )}
          </div>

          <div>
            <Label htmlFor="loanRepayments">
              Existing Loan Repayments (£) *
            </Label>
            <Input
              value={formData.loanRepayments?.toString() || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('loanRepayments', Number(e.target.value))}
              type="number"
              placeholder="0"
            />
            {errors.loanRepayments && (
              <span>{errors.loanRepayments}</span>
            )}
          </div>

          <div>
            <Label htmlFor="householdExpenses">
              Household Expenditure (£) *
            </Label>
            <Input
              value={formData.householdExpenses?.toString() || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('householdExpenses', Number(e.target.value))}
              type="number"
              placeholder="0"
            />
            {errors.householdExpenses && (
              <span>{errors.householdExpenses}</span>
            )}
          </div>

          <div>
            <Label htmlFor="dependentsCosts">
              Dependents' Costs (£) *
            </Label>
            <Input
              value={formData.dependentsCosts?.toString() || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateFormData('dependentsCosts', Number(e.target.value))}
              type="number"
              placeholder="0"
            />
            {errors.dependentsCosts && (
              <span>{errors.dependentsCosts}</span>
            )}
          </div>
        </div>
      </div>

      <div>
        <Paragraph>
          <strong>Note:</strong> Please provide accurate information about your monthly expenses. 
          This helps us calculate a realistic affordability assessment. Include all regular 
          monthly commitments such as groceries, utilities, insurance, childcare, and any 
          other regular expenses.
        </Paragraph>
      </div>
    </Block>
  );
};

export default FormStep3; 